import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {CarePlanService} from "../../models/care-plan-service.model";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {ClientsService} from "../../providers/clients.service";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {UserCarePlan} from "../../models/user-care-plan.model";
import {UserCarePlanService} from "../../providers/user-care-plan.service";
import {mobilePhoneNumberValidator} from "../../utils/form-validators";
import {WellnessPlan} from "../../models/wellness-plan.model";
import {WellnessPlanService} from "../../providers/wellness-plan.service";

@Component({
  selector: 'app-edit-user-care-plan',
  templateUrl: './edit-user-care-plan.component.html',
  styleUrls: ['./edit-user-care-plan.component.scss'],
})
export class EditUserCarePlanComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() userCarePlan: UserCarePlan;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<CarePlanService>();
  @Output() objectAddedEmitter = new EventEmitter<CarePlanService>();
  @Output() errorEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  hasUnsavedChanges: boolean = false;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  loggedUser: User;

  isBusy: boolean;
  dataLoaded: boolean = false;

  private isClientAdmin: boolean;
  private isGeneralWellnessPlanAdmin: boolean;
  clientSelected: Client;
  private subscriptions: Subscription = new Subscription();
  wellnessPlans: WellnessPlan[];
  wellnessPlan: WellnessPlan;


  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private router: Router,
    private userCarePlanService: UserCarePlanService,
    private clientsService: ClientsService,
    private wellnessPlanService: WellnessPlanService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralWellnessPlanAdmin = this.user.vClientId === null && this.user.vetcodeId === null && this.user.roles.split(';').filter(e => e === 'wellness-plan').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isClientAdmin = this.isAdmin && this.user.vClientId !== null && this.user.vetcodeId === null;

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowego abonenta';
      this.actionBtnLabel = 'Dodaj nowego abonenta';
      this.actionQuestion = 'Na pewno chcesz dodać nowego abonenta?';
      this.actionSuccess = 'Nowy abonent został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania abonenta'
      this.formGroup = this.formBuilder.group({
        carePlanOwnerCompany: ['', [Validators.required]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
        email: ['', [Validators.required, Validators.email]],
        wellnessPlanUUID: ['', [Validators.required]],
      });

      if (this.user.vClientUUID) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientByUUID(this.user.vClientUUID).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.fetchWellnessPlans(this.clientSelected.uuid);
          } else {
            this.appStateService.updateIsBusySubject(false);
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }

    } else {

      if (this.userCarePlan.vClientId) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientById('' + this.userCarePlan.vClientId).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.fetchWellnessPlans(this.clientSelected.uuid);
          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));

      }

      this.componentTitle = 'Zmień abonenta';
      this.actionBtnLabel = 'Zmień abonenta';
      this.actionQuestion = 'Na pewno chcesz zmienić abonenta?';
      this.actionSuccess = 'Abonent został zmieniony';
      this.actionError = 'Wystąpił błąd podczas zmiany abonenta';
      this.formGroup = this.formBuilder.group({
        carePlanOwnerCompany: [this.userCarePlan.carePlanOwnerCompany, [Validators.required]],
        firstName: [this.userCarePlan.firstName, [Validators.required]],
        lastName: [this.userCarePlan.lastName, [Validators.required]],
        mobilePhone: [this.userCarePlan.mobilePhone, [Validators.required, mobilePhoneNumberValidator]],
        email: [this.userCarePlan.email, [Validators.required, Validators.email]],
        wellnessPlanUUID: [this.userCarePlan.wellnessPlanUUID, [Validators.required]],
      });

    }

    super.ngOnInit();
  }


  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.actionCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.actionCanceledEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  goTo(page: string) {
    this.router.navigateByUrl(page);
  }


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let ucp: UserCarePlan = this.commonUtils.formGroupValuesToObject<UserCarePlan>(new UserCarePlan(), this.formGroup);

        let serviceMethod;

        this.userCarePlan.carePlanOwnerCompany = ucp.carePlanOwnerCompany;
        this.userCarePlan.firstName = ucp.firstName;
        this.userCarePlan.lastName = ucp.lastName;
        this.userCarePlan.mobilePhone = ucp.mobilePhone;
        this.userCarePlan.email = ucp.email;
        this.userCarePlan.wellnessPlanUUID = ucp.wellnessPlanUUID;

        if (this.clientSelected) {
          console.log(this.clientSelected)
          this.userCarePlan.vClientId = this.clientSelected.id;
        } else {
          this.userCarePlan.vClientId = Number.parseInt(this.user.vClientId);
        }

        if (this.action === 'EDIT') {
          serviceMethod = this.userCarePlanService.updateUserCarePlan(this.userCarePlan);
        } else {
          serviceMethod = this.userCarePlanService.addUserCarePlan(this.userCarePlan);
        }

        this.handleActionMethod(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter, this.errorEmitter);

      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }
  }


  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clientSelected = data.data;
        this.fetchWellnessPlans(this.clientSelected.uuid);
      }
    });

    return await modal.present();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  private fetchWellnessPlans(uuid: string) {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.wellnessPlanService.getByClientUUID(uuid).subscribe(wellnnessPlans => {
      this.appStateService.updateIsBusySubject(false);
      if (wellnnessPlans) {
        this.wellnessPlans = wellnnessPlans;
      } else {
        this.commonUtils.presentAlertToast('Brak zdefiniowanych rodzajów abonamentów');
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Nie można pobrać listy rodzajów abonamentów');
    }))
  }

  setWellnessPlan(uuid: any) {
    this.wellnessPlan = this.wellnessPlans.filter(w => w.uuid === uuid)[0];
    console.log(this.wellnessPlan);

  }

  translateFrequency(wellnessPlanItemFrequency: string) {
    if (wellnessPlanItemFrequency === 'MONTHLY') {
      return 'miesiąc';
    } else if (wellnessPlanItemFrequency === 'QUARTERLY') {
      return 'kwartał';
    } else if (wellnessPlanItemFrequency === 'ANNUALLY') {
      return 'rok';
    }

  }
}
